import ReactQuill from 'react-quill';

const Quill = ReactQuill.Quill;
const Embed = Quill.import('blots/embed');

class TemplateVariableBlot extends Embed {
    static blotName = 'template-variable';
    static tagName = 'span';
    static className = 'ql-template-variable';

    static create(value: string) {
        const node = super.create() as HTMLElement;
        node.setAttribute('data-variable', value);
        node.setAttribute('contenteditable', 'false');
        node.textContent = `[${value}]`;
        return node;
    }

    static value(node: HTMLElement): string {
        return node.getAttribute('data-variable') || '';
    }
}

Quill.register(TemplateVariableBlot);

export default TemplateVariableBlot;
